<!-- Header Start -->
<header class="header-hld header-invison">
    <section class="header-bot b5containeradjust">
      <div class="container">
        <div class="row">
          <div class="col-9 ">

          </div>
          <div class="col-3 text-end d-flex justify-content-end">


          </div>
        </div>
      </div>
    </section>
  </header>

  <header class="header-hld header-invison">
    <section class="header-bot ">
      <div class="container">
        <div class="row">
          <div class="col-9 ">
                    <a href="javascript:void(0)" title="Sanlam" class="logo-hld"
                        [routerLink]="userData!=null?['/portal/home']:['/register']">
                        <app-logo size="large" width="203" height="44" viewBox="0 0 203 44" fill="none"></app-logo>

            </a>
          </div>
          <div class="col-3 text-end d-flex justify-content-end">
            <button name="Header-Login" title="SanlamLogin" (click)="azureActivelogin()" id="Login_HL_Header" class="loginlink" *ngIf="userData==null">
                <span class="d-md-block d-none" id="Login_HL_Header_Text">Login</span>
                <span class="d-md-none d-block">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 4C12 6.21 10.21 8 8 8C5.79 8 4 6.21 4 4C4 1.79 5.79 0 8 0C10.21 0 12 1.79 12 4ZM0 14C0 11.34 5.33 10 8 10C10.67 10 16 11.34 16 14V16H0V14Z" fill="#8A929C"/>
                    </svg>
                </span>
              </button>
          </div>
        </div>
      </div>
    </section>
  </header>

<!-- Header HTML End -->

<section class="register ">
    <div class="container">
        <div class="login-hld" *ngIf="!signupSuccess">
            <div class="d-flex flex-wrap align-items-stretch">
                <div class="col-lg-6 col-md-7 px-3 regsterfrm">
                    <form [formGroup]="idNumberForm" (ngSubmit)="idNumberCheck()" id="id-number-form">
                        <h2 class="mx-md-0 pt-md-0 caption  mt-0" *ngIf="lesHeaderSuccessMsg!=''" [innerHTML]="lesHeaderSuccessMsg"></h2>
                        <h2 class="text-start pagecaption mt-md-2 bottomline" *ngIf="lesMiddleSuccessMsg!=''" [innerHTML]="lesMiddleSuccessMsg"></h2>
                        <p class="text-start px-md-0 mt-md-2 mt-0" *ngIf="lesSuccessMsg!=''">{{lesSuccessMsg}}</p>

                        <div class="">
                            <div *ngIf="errorMsg!=''" class="alert alert-danger mt-3" role="alert" [innerHTML]="errorMsg">
                            </div>
                            <div class="login-bg form-inline">
                                <div class="d-flex flex-wrap">
                                    <div class="required mb-md-0 col-md-8 col-12 px-0 inputspcemobile">
                                        <div class="form-field">
                                            <input id="IdNumber_HLRegistration" type="tel" class="form-control" placeholder="" formControlName="IdNumber"
                                                numeric-field maxlength="13">
                                            <label for="IdNumber">ID Number *</label>
                                            <div *ngIf="idNumberFormControls.IdNumber.touched && idNumberFormControls.IdNumber.errors"
                                                class="invalid-feedback">
                                                <div *ngIf="idNumberFormControls.IdNumber.errors.required">ID Number is required</div>
                                                <div *ngIf="idNumberFormControls.IdNumber.errors.minlength">ID Number must be 13 digits long
                                                </div>
                                                <div *ngIf="idNumberFormControls.IdNumber.errors.isValidIdNumber">Please enter your valid 13
                                                    digits South
                                                    African ID Number</div>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="col-md-4 col-12 pe-md-0 pe-0 ps-md-3 ps-0 mt-md-0">
                                        <button type="submit" class="btnregister w-100 mb-0" name="btnRegisterHLRegisterPage" id="HLRegister_Next_btn">
                                            Next
                                        </button>
                                    </div>
                                </div>

                                <div class="form-group w-100 pt-3 ps-0 mb-md-3 mb-0  pt-md-4 justify-content-between">

                                    <div class="pt-0 pt-md-0 w-100">
                                        <p class="text-start">Already have an account?
                                            <button type="button"  Name="Body-Login" id="Login_HL" (click)="azureAdlogin(false)" class="login-link">Login
                                            </button>
                                        </p>

                                    </div>
                                </div>
                                <div class="form-group fullwidth">
                                    <p class="text-start">
                                        We use your ID number to pull your credit information from the credit bureau into your personalised credit dashboard.
                                    </p>
                                </div>

                                <div class="form-group fullwidth w-100 pb-0 mb-3 d-flex align-items-center">
                                    <p class="text-start d-flex align-items-center m-0">
                                        <svg width="24" height="24" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.75 6H10.5C11.325 6 12 6.675 12 7.5V15C12 15.825 11.325 16.5 10.5 16.5H1.5C0.675 16.5 0 15.825 0 15V7.5C0 6.675 0.675 6 1.5 6H2.25V4.5C2.25 2.43 3.93 0.75 6 0.75C8.07 0.75 9.75 2.43 9.75 4.5V6ZM6 2.25C4.755 2.25 3.75 3.255 3.75 4.5V6H8.25V4.5C8.25 3.255 7.245 2.25 6 2.25ZM1.5 15V7.5H10.5V15H1.5ZM7.5 11.25C7.5 12.075 6.825 12.75 6 12.75C5.175 12.75 4.5 12.075 4.5 11.25C4.5 10.425 5.175 9.75 6 9.75C6.825 9.75 7.5 10.425 7.5 11.25Z" fill="#0075c9"/>
                                            </svg>
                                    <span class="ps-1 text-blue pt-1"> All personal information is secure and confidential.</span>
                                    </p>
                                </div>


                            </div>
                        </div>
                    </form>

                    <div id="auto-regitserFormText" style="display:none;">
                        <h2 class="mx-md-0 pt-md-0 caption bottomline mt-0"><strong  class="font-bolder">Register</strong> for your Credit Profile</h2>
                        <p class="text-start px-md-0 mt-md-2 mt-0">Your credit profile provides access to a unique view of your financial position. A coach will guide
                            you on your journey to reach your financial goals. You can browse through a range of solutions tailored to put you in
                            a stronger financial position.</p>
                    </div>

                    <form [formGroup]="registerWithIdnumberForm" (ngSubmit)="registerWithIdNumber()" id="auto-register-form"  style="display:none;" focusInvalidInput>
                        <div class="">
                               <div *ngIf="errorMsg!=''" class="alert alert-danger mt-3" role="alert" [innerHTML]="errorMsg">
                               </div>
                               <div class="login-bg form-inline">



                                   <div class="form-group fullwidth required"  *ngIf="!isHidden">
                                       <div class="form-field">
                                           <input id="Email_HLRegistrationPage_AutoReg" type="text" class="form-control" placeholder="" formControlName="Email">
                                           <label for="Email">Email Address *</label>
                                           <div *ngIf="registerWithIdnumberFormControls.Email.touched && registerWithIdnumberFormControls.Email.errors"
                                               class="invalid-feedback">
                                               <div *ngIf="registerWithIdnumberFormControls.Email.errors.required">Email address is required</div>
                                               <div *ngIf="registerWithIdnumberFormControls.Email.errors?.isValidEmail">Please enter a valid email
                                                   address</div>
                                           </div>
                                       </div>
                                   </div>

                                   <div class="form-group fullwidth required">
                                       <div class="form-field">
                                           <input id="Password_HLRegistrationPage_AutoReg" [type]="changetype?'password':'text'" class="form-control" placeholder=""
                                               formControlName="Password" [(ngModel)]="password"
                                               [closeDelay]="1000" [ngbPopover]="popContent" popoverTitle="Password Requirements" triggers="click:blur focus">
                                               <span class="eyeicon" (click)="viewpass()"><i><img ngOptimizedImage  [src]="visible?'assets/images/eye.png':'assets/images/eyeslash.png'"></i> </span>
                                               <label for="Password">Password *</label>
                                           <app-password-strength-bar *ngIf="password" [passwordToCheck]="password"
                                               [barLabel]="'Password strength:'" class="psb"></app-password-strength-bar>
                                           <div *ngIf="registerWithIdnumberFormControls.Password.touched && registerWithIdnumberFormControls.Password.errors"
                                               class="invalid-feedback">
                                               <div *ngIf="registerWithIdnumberFormControls.Password.errors.required">Password is required</div>
                                           </div>
                                       </div>
                                   </div>

                                   <div class="form-group fullwidth required confirmpw">
                                       <div class="form-field">
                                           <input id="ConfirmPassword_HLRegistrationPage_AutoReg" [type]="changetypec?'password':'text'" class="form-control" placeholder=""
                                               formControlName="ConfirmPassword">
                                               <span class="eyeicon" (click)="viewpassofConfirm()"><i><img ngOptimizedImage  [src]="visiblec?'assets/images/eye.png':'assets/images/eyeslash.png'"></i> </span>
                                           <label for="ConfirmPassword">Confirm Password *</label>
                                           <div *ngIf="registerWithIdnumberFormControls.ConfirmPassword.touched && registerWithIdnumberFormControls.ConfirmPassword.errors"
                                               class="invalid-feedback">
                                               <div *ngIf="registerWithIdnumberFormControls.ConfirmPassword.errors.required">Confirm password is
                                                   required</div>
                                               <div *ngIf="registerWithIdnumberFormControls.ConfirmPassword.errors.mustMatch">Password must match</div>
                                           </div>
                                       </div>
                                   </div>

                                   <div class="form-group mb-3 required form-group-full tc">
                                       <div class="form-check">
                                           <input class="form-check-input" type="checkbox" id="AcceptTerms_AutoReg" formControlName="AcceptTerms">
                                           <span>* I accept the <a href="/terms" id="TermsAndConditions_AutoReg" target="_blank">Terms and
                                               Conditions</a>; I give consent and hereby request my credit report.</span>
                                       </div>
                                       <div class="col-md-12 text-left">
                                           <div *ngIf="registerWithIdnumberFormControls.AcceptTerms.touched && registerWithIdnumberFormControls.AcceptTerms.errors"

                                               class="invalid-feedback left-0">
                                               <div *ngIf="registerWithIdnumberFormControls.AcceptTerms.errors.pattern"> Please confirm your acceptance of the terms and conditions.</div>
                                           </div>
                                       </div>
                                   </div>
                                   <div class="form-group fullwidth w-100 pb-0 mb-3 d-flex align-items-center">
                                        <p class="text-start d-flex align-items-center">
                                            <svg width="24" height="24" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.75 6H10.5C11.325 6 12 6.675 12 7.5V15C12 15.825 11.325 16.5 10.5 16.5H1.5C0.675 16.5 0 15.825 0 15V7.5C0 6.675 0.675 6 1.5 6H2.25V4.5C2.25 2.43 3.93 0.75 6 0.75C8.07 0.75 9.75 2.43 9.75 4.5V6ZM6 2.25C4.755 2.25 3.75 3.255 3.75 4.5V6H8.25V4.5C8.25 3.255 7.245 2.25 6 2.25ZM1.5 15V7.5H10.5V15H1.5ZM7.5 11.25C7.5 12.075 6.825 12.75 6 12.75C5.175 12.75 4.5 12.075 4.5 11.25C4.5 10.425 5.175 9.75 6 9.75C6.825 9.75 7.5 10.425 7.5 11.25Z" fill="#0075c9"/>
                                                </svg>

                                            <span class="ps-1 text-blue pt-1">All personal information is secure and confidential.</span>
                                        </p>
                                    </div>
                                    <div class="form-group fullwidth w-100 pt-0 mb-2 justify-content-between">
                                        <button type="submit" class="btnregister w-100" id="HLRegister_btn_AutoReg" name="btnRegisterHLRegisterPage">
                                            Register
                                        </button>
                                    </div>
                                    <div class="form-group fullwidth w-100 pt-3 justify-content-between">
                                        <div class="pt-0 pt-md-0 w-100">
                                            <p class="text-start">Have an account?
                                            <button type="button" Name="Body-Login" id="Login_HL_AutoReg" (click)="azureAdlogin(false)" class="login-link">Login</button>
                                        </div>
                                    </div>


                                    <ng-template #popContent>
                                        Be at least 8 characters <br>
                                        Uppercase and lowercase letter (A,z) <br>
                                        Numeric character (0-9) <br>
                                        Special character (!,%,&#64;,#,etc.)
                                    </ng-template>

                               </div>
                           </div>
                       </form>

                    <div id="registerFormText" style="display:none;">
                        <h2 class="mx-md-0 pt-md-0 caption bottomline mt-0"><strong  class="font-bolder">Register</strong> for your Credit Profile</h2>
                        <p class="text-start px-md-0 mt-md-2 mt-0">Your credit profile provides access to a unique view of your financial position. A coach will guide
                            you on your journey to reach your financial goals. You can browse through a range of solutions tailored to put you in
                            a stronger financial position.</p>
                    </div>

                    <form [formGroup]="registerForm" (ngSubmit)="register()" style="display:none;" id="registerForm" focusInvalidInput>

                        <div class="">
                            <div *ngIf="errorMsg!=''" class="alert alert-danger mt-3" role="alert" [innerHTML]="errorMsg">
                            </div>
                            <div class="login-bg form-inline">

                                <div class="form-group fullwidth required">
                                    <div class="form-field ">
                                        <input id="FirstName_HLRegistrationPage" type="text" class="form-control" placeholder=""
                                            formControlName="FirstName" name-field-hyphen-space>
                                        <label for="FirstName">First Name *</label>
                                        <div *ngIf="registerFormControls.FirstName.touched && registerFormControls.FirstName.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="registerFormControls.FirstName.errors.required">First name is required</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group fullwidth required">
                                    <div class="form-field">
                                        <input id="Surname_HLRegistrationPage" type="text" class="form-control" formControlName="Surname" placeholder=""
                                        name-field-with-space>
                                        <label for="Surname">Surname *</label>
                                        <div *ngIf="registerFormControls.Surname.touched && registerFormControls.Surname.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="registerFormControls.Surname.errors.required">Surname is required</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group fullwidth required">
                                    <div class="form-field ">
                                        <input id="PhoneNumber_HLRegistrationPage" type="tel" class="form-control" placeholder=""
                                            formControlName="PhoneNumber" numeric-field maxlength="10" (keyup)="cellNumberErrorMsg=''">
                                        <label for="PhoneNumber">Cell Phone Number *</label>
                                        <div *ngIf="(registerFormControls.PhoneNumber.touched && registerFormControls.PhoneNumber.errors) || cellNumberErrorMsg"
                                            class="invalid-feedback">
                                            <div *ngIf="registerFormControls.PhoneNumber.errors?.required">Cell phone number is required
                                            </div>
                                            <div *ngIf="registerFormControls.PhoneNumber.errors?.minlength">Cell phone number must be 10
                                                digits long</div>
                                            <div *ngIf="registerFormControls.PhoneNumber.errors?.isValidMobile">Please enter your valid
                                                10 digits cell
                                                phone number</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group fullwidth required">
                                    <div class="form-field">
                                        <input id="Email_HLRegistrationPage" type="text" class="form-control" placeholder="" formControlName="Email">
                                        <label for="Email">Email Address *</label>
                                        <div *ngIf="registerFormControls.Email.touched && registerFormControls.Email.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="registerFormControls.Email.errors.required">Email address is required</div>
                                            <div *ngIf="registerFormControls.Email.errors?.isValidEmail">Please enter a valid email
                                                address</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group fullwidth required">
                                    <div class="form-field gi-hld">
                                        <input id="IdNumber_HLRegistrationPage" type="tel" class="form-control" placeholder="" formControlName="IdNumber"
                                            numeric-field maxlength="13">
                                        <label for="IdNumber">ID Number *</label>
                                        <div *ngIf="registerFormControls.IdNumber.touched && registerFormControls.IdNumber.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="registerFormControls.IdNumber.errors.required">ID Number is required</div>
                                            <div *ngIf="registerFormControls.IdNumber.errors.minlength">ID Number must be 13 digits long
                                            </div>
                                            <div *ngIf="registerFormControls.IdNumber.errors.isValidIdNumber">Please enter your valid 13
                                                digits South
                                                African ID Number</div>
                                        </div>
                                    </div>

                                </div>


                                <div class="form-group fullwidth d-none">
                                    <div class="form-field">
                                        <input id="FinancialPlannerCode" type="tel" class="form-control" placeholder="" formControlName="FinancialPlannerCode"
                                            numeric-field maxlength="8">
                                            <label for="FinancialPlannerCode">Financial Planner Code</label>
                                            <div *ngIf="registerFormControls.FinancialPlannerCode.touched && registerFormControls.FinancialPlannerCode.errors"
                                                class="invalid-feedback">
                                                <div *ngIf="registerFormControls.FinancialPlannerCode.errors.minlength">Financial Planner Code  must be 8 digits long
                                                </div>
                                            </div>
                                    </div>
                                </div>

                                <div class="form-group-full">
                                    <div class="text-lg paddpb">
                                        We use your ID number to pull your credit information from the credit bureau into your personalised credit dashboard.
                                </div>
                                </div>

                                <div class="form-group fullwidth required">
                                    <div class="form-field">
                                        <input id="Password_HLRegistrationPage" [type]="changetype?'password':'text'" class="form-control" placeholder=""
                                            formControlName="Password" [(ngModel)]="password"
                                            [closeDelay]="1000" [ngbPopover]="popContent" popoverTitle="Password Requirements" triggers="click:blur focus">
                                            <span class="eyeicon" (click)="viewpass()"><i><img ngOptimizedImage  [src]="visible?'assets/images/eye.png':'assets/images/eyeslash.png'"></i> </span>
                                            <label for="Password">Password *</label>
                                        <app-password-strength-bar *ngIf="password" [passwordToCheck]="password"
                                            [barLabel]="'Password strength:'" class="psb"></app-password-strength-bar>
                                        <div *ngIf="registerFormControls.Password.touched && registerFormControls.Password.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="registerFormControls.Password.errors.required">Password is required</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group fullwidth required confirmpw">
                                    <div class="form-field">
                                        <input id="ConfirmPassword_HLRegistrationPage" [type]="changetypec?'password':'text'" class="form-control" placeholder=""
                                            formControlName="ConfirmPassword">
                                            <span class="eyeicon" (click)="viewpassofConfirm()"><i><img ngOptimizedImage  [src]="visiblec?'assets/images/eye.png':'assets/images/eyeslash.png'"></i> </span>
                                        <label for="ConfirmPassword">Confirm Password *</label>
                                        <div *ngIf="registerFormControls.ConfirmPassword.touched && registerFormControls.ConfirmPassword.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="registerFormControls.ConfirmPassword.errors.required">Confirm password is
                                                required</div>
                                            <div *ngIf="registerFormControls.ConfirmPassword.errors.mustMatch">Password must match</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group required mb-3 form-group-full tc">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="AcceptTerms_HL_RegistrationPage" formControlName="AcceptTerms">
                                        <span>* I accept the <a href="/terms" id="TermsAndConditions_HL_RegistrationPage" target="_blank">Terms and
                                            Conditions</a>; I give consent and hereby request my credit report.</span>
                                    </div>
                                    <div class="col-md-12 text-left">
                                        <div *ngIf="registerFormControls.AcceptTerms.touched && registerFormControls.AcceptTerms.errors"

                                            class="invalid-feedback left-0">
                                            <div *ngIf="registerFormControls.AcceptTerms.errors.pattern">Please confirm your acceptance of the terms and conditions.</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group fullwidth w-100 pb-0 mb-3 d-flex align-items-center">
                                    <p class="text-start d-flex align-items-center">
                                        <svg width="24" height="24" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.75 6H10.5C11.325 6 12 6.675 12 7.5V15C12 15.825 11.325 16.5 10.5 16.5H1.5C0.675 16.5 0 15.825 0 15V7.5C0 6.675 0.675 6 1.5 6H2.25V4.5C2.25 2.43 3.93 0.75 6 0.75C8.07 0.75 9.75 2.43 9.75 4.5V6ZM6 2.25C4.755 2.25 3.75 3.255 3.75 4.5V6H8.25V4.5C8.25 3.255 7.245 2.25 6 2.25ZM1.5 15V7.5H10.5V15H1.5ZM7.5 11.25C7.5 12.075 6.825 12.75 6 12.75C5.175 12.75 4.5 12.075 4.5 11.25C4.5 10.425 5.175 9.75 6 9.75C6.825 9.75 7.5 10.425 7.5 11.25Z" fill="#0075c9"/>
                                            </svg>

                                        <span class="ps-1 text-blue pt-1">All personal information is secure and confidential.</span>
                                    </p>
                                </div>
                                <div class="form-group fullwidth w-100 pt-0 mb-2 justify-content-between">
                                    <button type="submit" class="btnregister w-100" name="btnRegisterHLRegisterPage" id="HLRegister_btn">
                                        Register
                                    </button>
                                </div>
                                <div class="form-group fullwidth w-100 pt-3 justify-content-between">
                                    <div class="pt-0 pt-md-0 w-100">
                                        <p class="text-start">Have an account?
                                        <button type="button" Name="Body-Login" id="Login_HL_RegistrationPage" (click)="azureAdlogin(false)" class="login-link">Login</button>
                                    </div>
                                </div>
                                <ng-template #popContent>
                                    Be at least 8 characters <br>
                                    Uppercase and lowercase letter (A,z) <br>
                                    Numeric character (0-9) <br>
                                    Special character (!,%,&#64;,#,etc.)
                                </ng-template>

                            </div>
                        </div>


                    </form>

                    <figure class="m-0 d-block d-md-none">
                        <div class="bgmg position-relative">
                            <img ngOptimizedImage  _ngcontent-uhr-c2="" alt="" class="ps-lg-5" src="../../assets/images/HL-Registeration.jpg">

                        </div>
                    </figure>


                </div>
                <div class="col-lg-6 col-md-5 col-12 d-flex flex-wrap pt-lg-3 ps-lg-5 ps-3 pe-lg-3 pe-3 boxblue align-items-stretch">


                    <section class="d-flex align-items-stretch w-100 flex-wrap ps-lg-5">
                        <figure class="m-0 p- ps-md-5 d-md-block d-none w-100">
                            <div class="bgmg position-relative">
                                <img ngOptimizedImage  _ngcontent-uhr-c2="" alt="" class="ps-lg-5" src="../../assets/images/HL-Registeration.jpg">

                            </div>
                        </figure>
                            <div class="helpline position-relative d-flex flex-wrap w-100">
                                <div class="col-md-12 col-12 center-align px-3">
                                    <h2 class="mb-3 loginpage-caption bottomline">Need <b class="font-bolder"> help?</b></h2>
                                    <a class="phhelp" href="tel:+27860726526">+27 86 006 1058</a>
                                    <p class="mt-3 horset">Monday – Thursday 07:00-17:00</p>
                                    <p class="mt-3 horset">Friday 07:00-16:00</p>
                                </div>
                            </div>

                    </section>
                </div>
            </div>
        </div>

        <div class="login-hld" *ngIf="signupSuccess" style="height: 200px;">
            <h2>
                Registration Successful, <a href="javascript:void(0)" (click)="azureAdlogin(false)">click here to login</a>
            </h2>
        </div>
    </div>
</section>

<ng-template #captureIncomeModel let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-title-hlreg-income">Enter Your Take Home Salary</h4>
        <button name="btntCloseTakeHomeSalaryModelHLRegisterPage" type="button" class="close" aria-label="Close"
            (click)="openLandingHomePage()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form class="capture-income-form" [formGroup]="captureIncomeForm" (ngSubmit)="updateIncome()">
        <div class="modal-body">
            <div *ngIf="captureIncomeErrorMsg!=''" class="alert alert-danger" role="alert">
                {{captureIncomeErrorMsg}}
            </div>
            <div class="form-group fullwidth">
                <div class="form-field  gi-hld">
                    <input class="form-control" type="text" appCurrencyMask placeholder="R 20,000"
                        formControlName="GrossIncome" id="currency-number" (blur)="changeGrossIncome()">
                    <label for="GrossIncome">Take Home Salary</label>
                    <div *ngIf="captureIncomeFormControls.GrossIncome.touched && captureIncomeFormControls.GrossIncome.errors"
                        class="invalid-feedback">
                        <div *ngIf="captureIncomeFormControls.GrossIncome.errors.required">Take Home Salary is
                            required</div>
                        <div *ngIf="captureIncomeFormControls.GrossIncome.errors.min">Invalid Take Home Salary</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button name="btntSkipTakeHomeSalaryHLRegisterPage" type="button" class="btn"
                (click)="openLandingHomePage()">Skip</button>
            <button name="btntSubmitTakeHomeSalaryHLRegisterPage" type="submit" class="btn-border">Submit</button>
        </div>
    </form>
</ng-template>

<!-- Footer HTML Start -->
<app-footer></app-footer>

<!-- Footer HTML End -->
